import React from "react";
import Navbar from "../components/Navbar/Navbar";
import Rating from "../components/Rating/Rating";
import Movie from "../components/Movie/Movie";
import InfiniteScroll from "react-infinite-scroll-component";
import axios from "axios";
import { v4 as uuid } from "uuid";

function FilterByRating() {
  const [movies, setMovies] = React.useState([]);
  const [hasMore, setHasMore] = React.useState(true);
  const [page, setCurrentPage] = React.useState(1);
  const [rating, setRating] = React.useState(0);
  const [ratingIsChanged, setRatingIsChanged] = React.useState(false);

  React.useEffect(() => {
    const getMovies = async () => {
      const response = await axios({
        method: "GET",
        url: `https://api.themoviedb.org/3/discover/movie?api_key=${process.env.REACT_APP_API_KEY}`,
        params: {
          include_adult: false,
          "vote_average.gte": rating * 2,
          page: page,
        },
      });

      page > 1
        ? setMovies([...movies, ...response.data.results])
        : setMovies(response.data.results);

      if (ratingIsChanged && page === 1) setMovies(response.data.results);

      response.data.results.length === 0 || response.data.results.length < 20
        ? setHasMore(false)
        : setHasMore(true);
    };

    getMovies().catch(alert);
  }, [rating, page]);

  const createUniqueId = () => {
    const unique_id = uuid();
    return unique_id;
  };

  const handleScroll = () => {
    setCurrentPage((prev) => prev + 1);
  };

  const updateSelectedRating = (selectedRating) => {
    setRating(selectedRating);
    setCurrentPage(1);
    setRatingIsChanged(true);
  };

  return (
    <>
      <Navbar />
      <div className="container">
        <Rating updateSelectedRating={updateSelectedRating} />
        <h3 className="text-start">Movies</h3>
        <hr className="mt-3" />
        <InfiniteScroll
          dataLength={movies.length}
          next={handleScroll}
          hasMore={hasMore}
          style={{ overflow: "hidden" }}
        >
          <div className="row mt-5">
            {movies.map((movie) => (
              <Movie key={createUniqueId()} movie={movie} />
            ))}
          </div>
        </InfiniteScroll>
      </div>
    </>
  );
}

export default FilterByRating;
